// extracted by mini-css-extract-plugin
export default {"employerInfo":"EmployerInfo_employerInfo__A+r3U","spin":"EmployerInfo_spin__TnTFP"};